export default "__VITE_ASSET__nTZ1mUQk__"